import { DsFormTypeEnum } from '../enums/ds-forms.enum';

export const DS_FIELDS_STATIC_TABLE = [
  DsFormTypeEnum.TEXT,
  DsFormTypeEnum.DATE,
  DsFormTypeEnum.DATETIME,
  DsFormTypeEnum.NUMBER,
  DsFormTypeEnum.LISTBOX,
  DsFormTypeEnum.CHOICE,
  DsFormTypeEnum.SIGNATURE,
  DsFormTypeEnum.PHOTO,
  DsFormTypeEnum.DOCUMENT,
  DsFormTypeEnum.TEXTAREA,
] as const;
